import script from "./KQuickAccessCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KQuickAccessCard.vue?vue&type=script&setup=true&lang=ts"

import "./KQuickAccessCard.vue?vue&type=style&index=0&id=7cd03f76&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd03f76"]])

export default __exports__